// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"465":"b332fc08","1022":"b332fc08","1536":"b332fc08","1816":"b332fc08","2600":"b332fc08","3820":"b332fc08","8996":"b332fc08"}[chunkId] + ".chunk.css";
};